import { createAction, type Dispatch } from '@reduxjs/toolkit';
import type { RootState } from '@/app/store';
import { api } from '@/lib/trpc/client';

type B24StatusItem = {
  name: string | null;
  kwNumber: string | null;
  productCode: string | null;
  sapId: string | null;
  color: string;
  ean: string | null;
  size: string | null;
  requestedAmount: number;
  confirmedAmount: number;
  b24Status: string | null;
  hasChanges: boolean;
  deliveryWeekChange: boolean;
  requestedDeliveryDate: string | null;
  requestedDeliveryWeek: number | null;
  requestedDeliveryTimestamp: number | null;
  confirmedDeliveryDate: string | null;
  confirmedDeliveryWeek: number | null;
  amountChange: boolean;
};

export const salesOrderB24StatusRequestStarted = createAction(
  'sales-order-b24-status/request/started'
);
export const salesOrderB24StatusRequestFailed = createAction<string>(
  'sales-order-b24-status/request/failed'
);
export const salesOrderB24StatusRequestSucceeded = createAction<B24StatusItem[]>(
  'sales-order-b24-status/fetch/succeeded'
);
export const setSalesOrderB24StatusActiveFilters = createAction<{ changedOnly: boolean }>(
  'sales-order-b24-status/active-filters/save'
);

export const fetchSalesOrderB24StatusItems =
  (salesOrderGroupId: number, shopId: number) =>
  (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(salesOrderB24StatusRequestStarted());

    const state = getState();
    const userState = state.user;
    const { activeChain } = userState;

    return api.salesOrders.getOrderB24StatusItemRows
      .query({
        salesOrderGroupId,
        shopId,
        chain: activeChain,
      })
      .then(
        (data) => {
          dispatch(salesOrderB24StatusRequestSucceeded(data.result));
        },
        ({ message }) => dispatch(salesOrderB24StatusRequestFailed(message))
      );
  };
